import { create } from 'zustand';
import { getState, useState } from '@/framework';
import type { IExportState, StateType } from '@/version-types';
import { GetCustomContextMenuFn } from '../type';

/** 状态 */
interface IState {
    /** 显示高级(AI)操作 */
    showAdvancedAIOperation: boolean;
    /** 自定义右键菜单 */
    getCustomContextMenu: GetCustomContextMenuFn;
    /** 是否禁用右键菜单 */
    disableMenu: boolean;
    /** 隐藏右键菜单类型 */
    hiddenContextMenuTypes: Array<string>;
}

/** 动作 */
interface IAction {
    /** 设置自定义右键菜单 */
    setCustomContextMenuFn: (customContextMenuFn: GetCustomContextMenuFn) => void;
    /** 设置是否禁用右键菜单 */
    setDisableMenu: (disableMenu: boolean) => void;
    /** 设置隐藏右键菜单类型 */
    setHiddenContextMenuTypes: (hiddenContextMenuTypes: Array<string>) => void;
    /** 设置是否显示高级(AI)操作 */
    setShowAdvancedAIOperation(showAdvancedAIOperation: boolean): void;
}

/** 存储类型 */
interface IStore extends IState, IAction {}

/** 创建存储 */
const createState = (_: string) => {
    const store = create<IStore>((set) => ({
        getCustomContextMenu: () => null,
        setCustomContextMenuFn(getCustomContextMenu) {
            set({ getCustomContextMenu });
        },

        disableMenu: false,
        setDisableMenu(disableMenu) {
            set({ disableMenu });
        },

        hiddenContextMenuTypes: [],
        setHiddenContextMenuTypes(hiddenContextMenuTypes) {
            set({ hiddenContextMenuTypes });
        },

        showAdvancedAIOperation: true,
        setShowAdvancedAIOperation(showAdvancedAIOperation: boolean) {
            set({ showAdvancedAIOperation });
        },
    }));

    return store;
};

/** 存储名称 */
const name = 'context-menu-state';

/** 存储类型 */
type ModuleType = StateType<IStore, typeof name>;

/** hook 获取存储 */
export const useContextMenuState = () => {
    return useState<ModuleType>()[name];
};

/** 通过 id 获取存储 */
export const getContextMenuState = (identity: string) => {
    return getState<ModuleType>(identity)[name].getState();
};

const exportState: IExportState = {
    name,
    createState,
};

export default exportState;
